import React from 'react';

import SummaryBox from '../SummaryBox';
import { ISummaryBoxProps } from '../SummaryBox/types';

const NotarySummaryBox: React.FC<ISummaryBoxProps> = ({ mainData, ...props }) => (
  <SummaryBox {...props} title='Payable to Notaries' mainData={mainData} mark='-' mainDataColor='#DE9203' />
);

export default React.memo(NotarySummaryBox);
